<template>
  <footer class="footer has-text-black-ter" :style="{ backgroundColor: config.footer_bgcolor}">
    <div class="container">
      <div class="columns">
        <div class="column">
          <div class="columns">
            <div class="column">
              <img
                src="@/assets/img/logo-smile.svg"
                alt="KidsTopia"
                width="150"
                height="150"
                class="mb-2"
              />
            </div>
          </div>
          <span>© 2020 - 2025 </span>
        </div>
        <div class="column">
          <div>
            <strong class="is-uppercase">OPENING HOURS</strong>
            <ul class="mt-2">
              <li class="flex-item-center">
                <img
                  class="far fa-envelope has-text-primary mr-2 address-log"
                  src="../../assets/img/time.png"
                />
                <div class="hours-div" v-html="config.time"></div>
              </li>
            </ul>
          </div>
          <div class="mt-4">
            <strong class="is-uppercase">ADDRESS</strong>
            <ul class="mt-2">
              <li>
                <a
                  :href="config.address_map_url"
                  class="has-text-black-ter link flex-item-center"
                >
                  <img
                    class="far fa-envelope has-text-primary mr-2 address-log"
                    src="../../assets/img/son_address.png"
                  />
                  Get Direction
                </a>
              </li>
              <li>
                <span class="text-muted">{{ config.address }}</span>
              </li>
            </ul>
          </div>
          <div class="mt-4 is-hidden-tablet">
            <strong class="is-uppercase">CONTACT</strong>
            <ul class="mt-2">
              <li>
                <a
                  :href="`tel:+${config.phone}`"
                  class="has-text-black-ter link flex-item-center"
                >
                  <img
                    class="fas fa-phone-alt has-text-grey-dark mr-2 address-log"
                    src="../../assets/img/phone.png"
                  />
                  {{ config.phone }}
                </a>
              </li>
              <li>
                <a
                  :href="`mailto:${config.email}`"
                  class="has-text-black-ter link flex-item-center"
                >
                  <img
                    class="fas fa-phone-alt has-text-grey-dark mr-2 address-log"
                    src="../../assets/img/son-email-1.png"
                  />
                  {{ config.email }}
                </a>
              </li>
              <li>
                <a
                  class="has-text-black-ter link flex-item-center"
                  @click="goBookPatry"
                >
                  <img
                    class="fas fa-phone-alt has-text-grey-dark mr-2 address-log"
                    src="../../assets/img/book-party.png"
                  />
                  Booking Online
                </a>
              </li>
            </ul>
          </div>
          <div class="mt-4 is-hidden-tablet">
            <strong class="is-uppercase">CONNECT WITH US</strong>
            <ul class="mt-2">
              <li>
                <a
                  v-if="config.fb_account"
                  @click="openOther(config.fb_account)"
                  target="_blank"
                  style="cursor: pointer"
                  class="mr-4"
                  ><img src="@/assets/img/logo-FB.png" style="max-height: 25px"
                /></a>
                <a
                  v-if="config.instagram_account"
                  @click="openOther(config.instagram_account)"
                  target="_blank"
                  style="cursor: pointer"
                  ><img
                    src="@/assets/img/logo-INS.png"
                    style="max-height: 25px"
                /></a>
              </li>
            </ul>
          </div>
          <div class="mt-4 is-hidden-tablet">
            <hr />
            <strong class="is-uppercase">EXPLORE</strong>
            <ul class="mt-2">
              <li v-for="(item, index) in footerTabList" :key="index">
                <a class="has-text-black-ter link" :href="item.path">
                  {{ item.title }}
                  <span
                    v-if="item.show_hot == 1"
                    class="tag has-text-weight-semibold is-danger ml-2"
                    >HOT</span
                  >
                </a>
              </li>
            </ul>
            <hr />
            <ul>
              <li>
                <a class="has-text-black-ter link" href="/policy/privacy"
                  >Privacy Policy</a
                >
              </li>
              <li>
                <a class="has-text-black-ter link" href="/policy/terms"
                  >Terms and Conditions</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="column is-hidden-mobile">
          <div>
            <strong class="is-uppercase">CONTACT</strong>
            <ul class="mt-2">
              <li>
                <a
                  :href="`tel:+${config.phone}`"
                  class="has-text-black-ter link flex-item-center"
                >
                  <img
                    class="fas fa-phone-alt has-text-grey-dark mr-2 address-log"
                    src="../../assets/img/phone.png"
                  />
                  {{ config.phone }}
                </a>
              </li>
              <li>
                <a
                  :href="`mailto:${config.email}`"
                  class="has-text-black-ter link flex-item-center"
                  ><img
                    class="fas fa-phone-alt has-text-grey-dark mr-2 address-log"
                    src="../../assets/img/son-email-1.png"
                  />{{ config.email }}
                </a>
              </li>
              <li>
                <a
                  class="has-text-black-ter link flex-item-center"
                  @click="goBookPatry"
                  ><img
                    class="fas fa-phone-alt has-text-grey-dark mr-2 address-log"
                    src="../../assets/img/book-party.png"
                  />Booking Online</a
                >
              </li>
            </ul>
          </div>
          <div class="mt-4">
            <strong class="is-uppercase">CONNECT WITH US</strong>
            <ul class="mt-2">
              <li>
                <a
                  v-if="config.fb_account"
                  @click="openOther(config.fb_account)"
                  target="_blank"
                  rel="noopener"
                  class="mr-4"
                  ><img src="@/assets/img/logo-FB.png" style="max-height: 25px"
                /></a>
                <a
                  v-if="config.instagram_account"
                  @click="openOther(config.instagram_account)"
                  target="_blank"
                  rel="noopener"
                  ><img
                    src="@/assets/img/logo-INS.png"
                    style="max-height: 25px"
                /></a>
              </li>
              <li class="nav-item"></li>
            </ul>
          </div>
        </div>
        <div class="column is-hidden-mobile">
          <strong class="is-uppercase">EXPLORE</strong>
          <ul class="mt-2">
            <li v-for="(item, index) in footerTabList" :key="index">
              <a class="has-text-black-ter link" @click="openLink(item.path)">
                {{ item.title }}
                <span
                  v-if="item.show_hot == 1"
                  class="tag has-text-weight-semibold is-danger ml-2"
                  >HOT</span
                >
              </a>
            </li>
          </ul>
          <hr />
          <ul>
            <li>
              <a
                class="has-text-black-ter link"
                @click="openLink('/policy/privacy')"
                >Privacy Policy</a
              >
            </li>
            <li>
              <a
                class="has-text-black-ter link"
                @click="openLink('/policy/terms')"
                >Terms and Conditions</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import store from "@/store";
export default {
  props: {
    config: {
      default: {},
      type: Object,
    },
  },
  components: {},
  computed: {
    footerTabList() {
      return store.state.global.footerTabs || [];
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    openOther(url) {
      window.open(`${url}/?from=web-footer`);
    },
    openLink(path) {
      this.$router.push({
        path: path,
      });
    },
    goBookPatry() {
      this.$router.push({
        path: '/pricing/party',
      });
    }
  },
};
</script>
<style scoped>
article,
aside,
figure,
footer,
header,
hgroup,
section {
  display: block;
}
footer {
  margin-top: 1rem;
  padding-bottom: 3rem;
}
.footer {
  background-color: #fafafa;
  padding: 3rem 1.5rem 6rem;
}
.has-text-black-ter {
  color: #242424 !important;
}
.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}
@media screen and (min-width: 1024px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1408px) {
  .container:not(.is-max-desktop):not(.is-max-widescreen) {
    max-width: 1344px;
  }
}
.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}
.columns:last-child {
  margin-bottom: -1.5rem;
}
@media print, screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
}
.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
}
img {
  height: auto;
  max-width: 100%;
}
.mb-2 {
  margin-bottom: 0.5rem !important;
}
.mt-2 {
  margin-top: 0.5rem !important;
}
.mr-2 {
  margin-right: 0.5rem !important;
}
.mt-4 {
  margin-top: 1rem !important;
}
.mr-4 {
  margin-right: 1rem !important;
}
.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}
span {
  font-style: inherit;
  font-weight: inherit;
}
strong {
  color: #363636;
  font-weight: 700;
}
.is-uppercase {
  text-transform: uppercase !important;
}

ul {
  list-style: none;
}
.far {
  font-family: "Font Awesome 5 Pro";
  font-weight: 400;
}
.has-text-grey-dark {
  color: #757763 !important;
}
.day {
  font-weight: 600;
}
span {
  font-style: inherit;
  font-weight: inherit;
}
.link {
  cursor: pointer;
}
.link:hover {
  font-weight: 600;
}
@media print, screen and (min-width: 769px) {
  .is-hidden-tablet {
    display: none !important;
  }
}
.tag:not(body).is-danger {
  background-color: #de4c50;
  color: #fff;
}
.tag:not(body) {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #757763;
  display: inline-flex;
  font-size: 0.75rem;
  height: 2em;
  justify-content: center;
  line-height: 1.5;
  padding-left: 0.75em;
  padding-right: 0.75em;
  white-space: nowrap;
}
.has-text-weight-semibold {
  font-weight: 600 !important;
}
hr {
  border: none;
  display: block;
  height: 2px;
  margin: 1.5rem 0;
}
code,
hr {
  background-color: #f5f5f5;
}
.hours-div {
  white-space: pre-line;
}
.address-log {
  max-width: 20px;
}
.flex-item-center {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/SonFooter.vue